import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkTransitInfo
} from "@/src/actions/flightAction";
import { HiOutlineArrowsRightLeft } from "react-icons/hi2";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import { Button } from "@/components/ui/button";
import FlightItineraryDetail from "./search/FlightItineraryDetail";
import { getFormattedTime } from "@/src/helpers/getFormattedTime";
import PricingInfo from "@/src/components/PricingInfo";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { useMediaQuery } from "@/hooks/use-media-query";

export default function FlightDetailPreviewSheet({
  open,
  openchange,
  selectedFareTypeFlight,
  flightInfo,
  handleBookItemCallback,
  fareTypeChangeEvent,
}) {
  const {
    flightSearchForm,
  } = useSelector((state) => state.flights);
  const odDetails = selectedFareTypeFlight.OriginDest;
  const searchOdDetails = flightSearchForm.originDestination;
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const toatlFlightTime = (flights) => {
    let totalTimeInSecs = 0;
    flights.forEach((flt) => {
      totalTimeInSecs += parseInt(flt.ElapsedTime);
    });
    return <span>{getFormattedTime(totalTimeInSecs)}</span>;
  };

  let totalPax = 0;
  flightSearchForm.passengerType.forEach((type) => {
    totalPax += type.quantity;
  })
  return (
    <Sheet open={open} onOpenChange={(e) => openchange(e)}>
      <SheetContent className="w-full sm:max-w-[640px] lg:min-w-[500px] flex-col flex h-dvh p-0 gap-0">
        <SheetHeader className="p-3">
          <SheetTitle>
            <>
              <div className="flex items-center text-xs lg:text-base gap-x-1 text-muted-foreground mb-2">
                <span>
                  {selectedFareTypeFlight.OriginDest.length > 1
                    ? "Round Trip"
                    : "One Way"}
                </span>
                <span className="block">•</span>
                <span>Economy</span>
                <span className="block">•</span>

                {isDesktop ?
                  <span>
                    {totalPax == 1
                      ? totalPax +
                      " Passenger"
                      : totalPax +
                      " Passengers"}
                  </span>
                  :
                  <span className="flex items-center space-x-2">
                    <span>{totalPax}</span>
                    <FaPersonWalkingLuggage />
                  </span>
                }
                <span className="block">•</span>
                <span>
                  {moment(searchOdDetails[0].departDateTime).format(
                    "ll"
                  )}
                </span>
                {searchOdDetails > 1 && (
                  <>
                    <span className="block">•</span>
                    <span>
                      {moment(
                        searchOdDetails[1].departDateTime
                      ).format("ll")}
                    </span>
                  </>
                )}
              </div>
              <div className="flex items-center text-xl gap-x-1">
                {searchOdDetails.length > 1 ? (
                  <>
                    <span>{searchOdDetails[0].origin}</span>
                    <HiOutlineArrowsRightLeft />
                    <span>{searchOdDetails[0].destination}</span>
                  </>
                ) : (
                  <>
                    <span>{searchOdDetails[0].origin}</span>
                    <HiOutlineArrowSmRight />
                    <span>{searchOdDetails[0].destination}</span>
                  </>
                )}
              </div>
            </>
          </SheetTitle>
        </SheetHeader>
        <SheetDescription className="flex-1 overflow-auto p-3">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            defaultValue="item0"
          >
            {odDetails.map((od, i) => {
              return (
                <AccordionItem
                  key={`accrItem${i}`}
                  value={`item${i}`}
                  className="border rounded-lg mb-3"
                >
                  <AccordionTrigger className="hover:no-underline px-4 py-2 text-foreground border-b">
                    <div className="flex gap-x-3 items-center">
                      <div className="">
                        <div className="flex gap-x-3">
                          {od.FlightDetails.map((fd, i) => {
                            return (
                              <img
                                id={
                                  fd.FlightNumber +
                                  fd.AirEquipType +
                                  i +
                                  "_id"
                                }
                                key={
                                  fd.FlightNumber +
                                  fd.AirEquipType +
                                  i +
                                  "_id"
                                }
                                src={fd.Logo}
                                alt=""
                                className="w-12 h:12 rounded object-contain"
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center text-sm gap-x-1">
                          <span>{i == 1 ? "Return" : "Departure"}</span>
                          <span className="block">•</span>
                          <span>
                            {moment(od.DepartureDateTime).format("lll")}
                          </span>
                        </div>
                        <div className="flex items-center text-xs lg:text-sm gap-x-1 text-muted-foreground">
                          <span>
                            {od.Origin} - {od.Destination}
                          </span>
                          <span className="block">•</span>
                          <span>
                            {toatlFlightTime(od.FlightDetails)} (
                            {od.FlightDetails.length == 1
                              ? "Non Stop"
                              : od.FlightDetails.length - 1 + " Stop"}
                            )
                          </span>
                        </div>
                      </div>
                    </div>
                  </AccordionTrigger>

                  <AccordionContent>
                    {flightInfo && od && <FlightItineraryDetail
                      key={od.Origin + i}
                      od={od}
                      flight={flightInfo}
                      fareTypeChangeEvent={fareTypeChangeEvent}
                      selectedFareTypeFlight={selectedFareTypeFlight}
                    />}
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </SheetDescription>
        <div className="flex items-center justify-between p-3 border-t">
          <span className="text-xl font-medium">
            <span className="text-sm">{selectedFareTypeFlight.FareOptions.Currency}{" "}</span>
            {selectedFareTypeFlight.FareOptions.GTotalFare.toLocaleString()}
          </span>
          <Button
            onClick={() => {
              handleBookItemCallback && handleBookItemCallback();
            }}
          >
            Book
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}
